import { ScrollView, StyleSheet, Text } from "react-native";
import { Row, Table } from "react-native-table-component";
import PageTitle from "../../../components/PageTitle";
import { formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function ProportionalTable({navigation, route}) {
    const tableData = route.params.tableDataItems
    const cutDay = route.params.cutDay
    const netValue = route.params.netValue
    const tableHead = ['Dia', 'Proporcional', 'Total']

    return <PageTitle title={"Proporcional por dia"} navigation={navigation}>
        <Table style={{ marginTop: 8 }}>
            <Row data={tableHead} style={table.head} textStyle={table.text} />
        </Table>
        <ScrollView
            style={{ width: "100%", marginVertical: 8 }}
        >
            <Table>
                {tableData.map((row, index) => {
                    const rowData = [row.day, formatMoneyBRL(row.proportionalValue), formatMoneyBRL(row.price)]
                    return <Row data={rowData} textStyle={table.textValue} style={rowData[0] == cutDay ? table.cellValueCutDay : table.cellValue} key={index} />
                })}
            </Table>
        </ScrollView>
        <Text style={styles.warning}>{`*A partir do dia ${cutDay.toString().padStart(2, "0")} é inclusa a mensalidade do mês seguinte`}</Text>
    </PageTitle>
}

const table = StyleSheet.create({
    head: { height: 40, backgroundColor: Colors.SECONDARY, borderRadius: 5 },
    text: { margin: 6, fontSize: Fonts.FONT_SIZE_16, color: Colors.SNOW, fontWeight: "500" },
    textValue: { margin: 6, fontSize: Fonts.FONT_SIZE_16 },
    cellValue: { borderBottomWidth: 1, borderColor: Colors.SECONDARY },
    cellValueCutDay: { borderBottomWidth: 1, borderColor: Colors.SECONDARY, backgroundColor: Colors.GRAY_MEDIUM }
});

const styles = StyleSheet.create({
    warning: {
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.SECONDARY,
        fontWeight: "500",
        textAlign: "center"
    },
})